import { mapGetters } from 'Vuex'
import store from '../store/index.js'
export default{
  computed:{
     ...mapGetters(['menusList','rid'])

  },
  mounted(){
  },
 created(){
 	},
  methods:{
	 async getDshsm(){
		  const { data: res } = await this.$http.getDshAuditShZlUser()
		  if(res.status === 0){
			if(res.data > 0){
				this.$notify({
					             title: '您好,管理员！',
								 // showClose:false,
								 offset:80,
								 duration: 0,
					             message: `您有 ${res.data} 条新用户待审核！请及时审核!`,
					             position: 'top-left'
					           });
			}
			
		  }
	  },
	  
	  
    dtrouter(){
	//console.log(this.rid)
	
	if(this.rid == 1){
	this.getDshsm()
	}
	
	
    let routers =[
		//网页权限管理
		{ path:'/userList',
		  component:require('@/view/Rights/userList').default?require('@/view/Rights/userList').default:require('@/view/Rights/userList')
		},
		{ path:'/roleList',
		  component:require('@/view/Rights/roleList').default?require('@/view/Rights/roleList').default:require('@/view/Rights/roleList')
		},
		{ path:'/menuList',
		  component:require('@/view/Rights/menuList').default?require('@/view/Rights/menuList').default:require('@/view/Rights/menuList')
		},
		{ path:'/log-list',
		  component:require('@/view/Rights/logList').default?require('@/view/Rights/logList').default:require('@/view/Rights/logList')
		},
		{ path:'/query-logs',
		  component:require('@/view/Rights/queryLogsList').default?require('@/view/Rights/queryLogsList').default:require('@/view/Rights/queryLogsList')
		},
	  { path:'/homeList',
	      component:require('@/view/Rights/homeList').default?require('@/view/Rights/homeList').default:require('@/view/Rights/homeList')
	    },
			{ path:'/saleList',
			    component:require('@/view/Rights/specialShipList').default?require('@/view/Rights/specialShipList').default:require('@/view/Rights/specialShipList')
			  },
	//*******本地数据库********
	//海运港口
		{ path:'/port',
		  component:require('@/view/DataDictionary/port').default?require('@/view/DataDictionary/port').default:require('@/view/DataDictionary/port')
		},
		//空运港口
			{ path:'/airport',
			  component:require('@/view/DataDictionary/airPort').default?require('@/view/DataDictionary/airPort').default:require('@/view/DataDictionary/airPort')
			},
			//国际快递国家
				{ path:'/expressCountry',
				  component:require('@/view/DataDictionary/expressCountry').default?require('@/view/DataDictionary/expressCountry').default:require('@/view/DataDictionary/expressCountry')
				},
		//海运整箱
		{ path:'/fclbyseaData',
		  component:require('@/view/DataDictionary/fclBySeaData').default?require('@/view/DataDictionary/fclBySeaData').default:require('@/view/DataDictionary/fclBySeaData')
		},
		//海运拼箱
		{ path:'/lclbyseaData',
		  component:require('@/view/DataDictionary/lclBySeaData').default?require('@/view/DataDictionary/lclBySeaData').default:require('@/view/DataDictionary/lclBySeaData')
		},
		//空运
		{ path:'/byAirData',
		  component:require('@/view/DataDictionary/byAirData').default?require('@/view/DataDictionary/byAirData').default:require('@/view/DataDictionary/byAirData')
		},
		//内陆拖车
		{ path:'/trailerData',
		  component:require('@/view/DataDictionary/trailerData').default?require('@/view/DataDictionary/trailerData').default:require('@/view/DataDictionary/trailerData')
		},
		//铁路
		{ path:'/railRoadData',
		  component:require('@/view/DataDictionary/railroadData').default?require('@/view/DataDictionary/railroadData').default:require('@/view/DataDictionary/railroadData')
		},
		//国际快递
		{ path:'/expressData',
		  component:require('@/view/DataDictionary/expressData').default?require('@/view/DataDictionary/expressData').default:require('@/view/DataDictionary/expressData')
		},
	//微信小程序后台管理
	{ path:'/app-home',
	  component:require('@/view/WxAppManage/homeData').default?require('@/view/WxAppManage/homeData').default:require('@/view/WxAppManage/homeData')
	},
	{ path:'/app-order',
	  component:require('@/view/WxAppManage/orderData').default?require('@/view/WxAppManage/orderData').default:require('@/view/WxAppManage/orderData')
	},
	{ path:'/app-query',
	  component:require('@/view/WxAppManage/queryData').default?require('@/view/WxAppManage/queryData').default:require('@/view/WxAppManage/queryData')
	},
     ]
     let menus= this.menusList
      console.log(menus)
     routers = routers.filter(item=>{
     	return menus.some(val=>val.indexPath==item.path)
     })
	// console.log(routers)
     let resRoute = [{
     	path:'/',
     	redirect:'/home',
     	component:require('@/view/Index').default?require('@/view/Index').default:require('@/view/Index'),
     	children:
       [
         { path:'/home',
           component:require('@/view/Home/home').default?require('@/view/Home/home').default:require('@/view/Home/home')
         },
     		...routers
     	]
     }]
     //用以下的语法this.$router.addRoutes(resRoute)会报错，只能for方法
     //this.$router.addRoutes(resRoute)
     for (let i of resRoute) {
          this.$router.addRoute(i)
      }
    }

  }

}
